// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'production'
      ? 'https://monnaify-production.up.railway.app/api'
      : 'http://localhost:5001/api'),
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000'),
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
};

// Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'auth_token',
  USER: 'user_data',
  REFRESH_TOKEN: 'refresh_token',
};

// API Endpoints
export const ENDPOINTS = {
  AUTH: {
    REGISTER: '/auth/register',
    LOGIN: '/auth/login',
    ME: '/auth/me',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
  },
  HOUSES: {
    LIST: '/houses',
    CREATE: '/houses',
    JOIN: '/houses/join',
    DETAIL: (id) => `/houses/${id}`,
    MEMBERS: (id) => `/houses/${id}/members`,
    UPDATE: (id) => `/houses/${id}`,
    DELETE: (id) => `/houses/${id}`,
  },
  EXPENSES: {
    LIST: (houseId) => `/houses/${houseId}/expenses`,
    CREATE: (houseId) => `/houses/${houseId}/expenses`,
    UPDATE: (houseId, expenseId) => `/houses/${houseId}/expenses/${expenseId}`,
    DELETE: (houseId, expenseId) => `/houses/${houseId}/expenses/${expenseId}`,
    CALCULATE: (houseId) => `/houses/${houseId}/calculate`,
  },
  CATEGORIES: {
    LIST: '/categories',
  },
};
